import { render } from "./StaleChunkNote.vue?vue&type=template&id=020dff1e&scoped=true"
import script from "./StaleChunkNote.vue?vue&type=script&lang=js"
export * from "./StaleChunkNote.vue?vue&type=script&lang=js"

import "./StaleChunkNote.vue?vue&type=style&index=0&id=020dff1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020dff1e"]])

export default __exports__